import styled from '@emotion/styled';
import {
  Content,
  Section,
  SkeletonCardButtonSmallRounded,
  SkeletonHeaderHome,
  TextHeading2,
  token,
} from '@ferreri/prever-component-lib';

import { StyledGroupElementScroll } from '../../modules/home/StyledGroupElementScroll';
import { PageLayoutMenuFooter } from '../PageLayoutMenuFooter';
import { SkeletonProductSection } from './SkeletonSection';

export const SkeletonHomePage = () => {
  return (
    <PageLayoutMenuFooter>
      <SkeletonHome />
    </PageLayoutMenuFooter>
  );
};

export const SkeletonHome = () => {
  return (
    <>
      <SkeletonLocationStateSelect />
      <Content>
        <SkeletonHeaderHome />
        <Section>
          <TextHeading2>Mais acessados</TextHeading2>
          <StyledGroupElementScroll>
            {Array.from({ length: 4 }).map((_, index) => {
              return <SkeletonCardButtonSmallRounded key={index} />;
            })}
          </StyledGroupElementScroll>
        </Section>
        <Section>
          <TextHeading2>Todos os serviços</TextHeading2>
        </Section>
        {Array.from({ length: 5 }).map((_, index) => {
          return <SkeletonProductSection key={index} />;
        })}
      </Content>
    </>
  );
};

const SkeletonLocationStateSelect = styled.div`
  box-sizing: border-box;
  width: 100%;
  height: 58px;
  background-color: ${token.colors.backgroundAux};
`;
